<div class="kt-portlet">
    <div class="kt-portlet__body">
        <div class="kt-infobox">
            <div class="kt-infobox__header">
                <h2 class="kt-infobox__title">[{{getRequestType(request.requestType)}} - {{request.displayName}}] {{request.title}}</h2>
                <div class="kt-infobox__badge" *ngIf="!request.label">Negatif - {{request.score}}</div>
                <div class="kt-infobox__badge" *ngIf="request.label">Pozitif - {{request.score}}</div>
            </div>
            <div class="kt-infobox__body">
                <div class="kt-infobox__section">
                    <div class="kt-infobox__content">
                        {{request.message}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>